<template>
  <div v-if="config.sponsorLink" class="sponsor-banner" @click="openBannerLink">
    <img :src="config.sponsorImage" alt="Sponsor banner" />
  </div>
</template>

<script>
import { hybrid, openExternalUrl } from '@dpgradio/creative'
import { CAMPAIGN_CONFIG } from '../utils/config'

export default {
  name: 'SponsorBanner',
  data() {
    return {
      config: CAMPAIGN_CONFIG,
    }
  },
  methods: {
    openBannerLink() {
      if (this.config.sponsorLink) {
        openExternalUrl(this.config.sponsorLink, hybrid.OPEN_URL_MODES.EXTERNAL)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sponsor-banner {
  cursor: pointer;
  align-self: end;

  img {
    width: 100%;
    display: block;
  }
}
</style>
